import { LOCATION_FORM_STEPS } from "./constants";

export const getNextLocationStep = (
  currentForm: LOCATION_FORM_STEPS,
  response?: string,
) => {
  if (currentForm === LOCATION_FORM_STEPS.STATE && response === "New York") {
    return LOCATION_FORM_STEPS.VISIT_TYPE_PREFERENCE;
  } else if (
    currentForm === LOCATION_FORM_STEPS.VISIT_TYPE_PREFERENCE &&
    response !== "Telehealth"
  ) {
    return LOCATION_FORM_STEPS.OFFICE_PREFERENCE;
  } else return;
};

export const getPrevLocationStep = (currentForm: LOCATION_FORM_STEPS) => {
  if (currentForm === LOCATION_FORM_STEPS.OFFICE_PREFERENCE) {
    return LOCATION_FORM_STEPS.VISIT_TYPE_PREFERENCE;
  } else if (currentForm === LOCATION_FORM_STEPS.VISIT_TYPE_PREFERENCE) {
    return LOCATION_FORM_STEPS.STATE;
  } else return;
};

export const getLocationFormLastStep = (
  state: string,
  visitType?: string | null,
) => {
  if (state === "New York") {
    if (visitType !== "Telehealth") {
      return LOCATION_FORM_STEPS.OFFICE_PREFERENCE;
    } else {
      return LOCATION_FORM_STEPS.VISIT_TYPE_PREFERENCE;
    }
  } else {
    return LOCATION_FORM_STEPS.STATE;
  }
};
